import { HttpHeaders } from '@angular/common/http';
import { Component, Input, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
//import { AppConsts } from 'src/app/models/app-consts';
import { serviceConstants } from 'src/app/constants/service.constants';
import { AdobePdfViewerService } from 'src/app/services/adobe-pdf-viewer.service';
//import { AdobePdfViewerService } from 'src/app/Services/adobe-pdf-viewer.service';
import { UserService } from 'src/app/services/user.service';

@Component({
  selector: 'app-file-preview',
  templateUrl: './file-preview.component.html',
  styleUrls: ['./file-preview.component.scss']
})
export class FilePreviewComponent implements OnInit {

  public content: any;
  downloadPDFUrl: String = "";
  type:string;
  filename:string;
  fileid:string;
  decodedFileName:string;
  IsPreview:boolean = true;
  IsPlayasaudio:boolean = false;
  IsPlayasvideo:boolean = false;
  srcpath:SafeResourceUrl="";
  constructor(
    public modalRef: NgbActiveModal, 
    private pdfViewer: AdobePdfViewerService,
    private userService: UserService,
    public route: ActivatedRoute,
    private sanitizer:DomSanitizer,
  ) { 
    this.type = route.snapshot.params['type'];
    this.filename = route.snapshot.params['filename'];
    this.fileid = route.snapshot.params['fileid'];
  }

  ngOnInit(): void {
    this.decodedFileName=atob( this.filename);
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
      withCredentials: true
    };
    let orgid = this.userService.getOrganizationId();
    let FileExt = this.decodedFileName.split(".")[1];
   // this.downloadPDFUrl = serviceConstants.apiURL+ "api/File/Preview/" + this.content.Type + "/" + this.content.FileID;
   if(FileExt == "mp3" || FileExt == ".mp3"){
    this.IsPreview = false;
    this.IsPlayasaudio = true;
    this.IsPlayasvideo = false;
    let downloadUrl = serviceConstants.apiURL+ "api/Login/Preview?type=" + this.type + "&id=" + this.fileid+"&OrgId="+orgid;
      this.srcpath =  this.sanitizer.bypassSecurityTrustResourceUrl(downloadUrl);
  }
  else if(FileExt == "mp4" || FileExt == ".mp4" || FileExt == "mov" || FileExt == ".mov" || FileExt == "avi" || FileExt == ".avi"){
    this.IsPreview = false;
    this.IsPlayasaudio = false;
    this.IsPlayasvideo = true;
    let downloadUrl = serviceConstants.apiURL+ "api/Login/Preview?type=" + this.type + "&id=" + this.fileid+"&OrgId="+orgid;
      this.srcpath =  this.sanitizer.bypassSecurityTrustResourceUrl(downloadUrl);
  }
else{
    this.pdfViewer.ready().then(() => {
      let Url=serviceConstants.apiURL+ "api/Login/Preview?type=" + this.type + "&id=" + this.fileid+"&OrgId="+orgid,httpOptions;
      this.pdfViewer.previewFile(
        "file-preview-div",Url,
       // AppConsts.ApiServiceBaseUrl + "api/file/preview?type=" + this.Content.Type + "&id=" + this.Content.FileID,
        //AppConsts.ApiServiceBaseUrl + `api/file/download/${this.Content.Type}/${this.Content.FileID}`,
        this.decodedFileName,
        { showPageControls: true, showLeftHandPanel: true }
      )
    })
  }
}

  close() {
    this.modalRef.dismiss();
  }

}
